import React from "react";
import { brandAssets, commerce } from "../../data/commerce";
export function Footer() {
  const year = new Date().getFullYear();
  return <footer className="border-t border-pizarra/10 bg-marfil" data-id="element-100" data-mp="kjrubt2gt8nx">
      <div className="mx-auto flex max-w-6xl flex-col gap-8 px-4 py-12 md:flex-row md:items-center md:justify-between md:px-6" data-id="element-101" data-mp="6ljnmtfmmszk">
        <div className="flex items-center gap-4" data-id="element-102" data-mp="aksjq4y532ya">
          <img src={brandAssets.logo} alt="Recursos Practic & Simple" loading="lazy" className="h-14 w-auto mix-blend-multiply" data-id="element-103" data-mp="3t0mlib9wh4m6" />
          <div data-id="element-104" data-mp="1mqjvsq56gcl">
            <p className="font-semibold text-pizarra-deep" data-id="element-105" data-mp="1n9sujxtdueh">Recursos Practic & Simple</p>
            <p className="text-sm text-pizarra-soft" data-id="element-106" data-mp="3j3hvu1guir0m">Megapack para Aprender Japonés · Ebooks en PDF</p>
          </div>
        </div>
        <div className="flex flex-col gap-3 text-sm text-pizarra md:items-end" data-id="element-107" data-mp="3nz72spv73a6y">
          {commerce.contactEmail.trim() && <a href={`mailto:${commerce.contactEmail}`} className="hover:text-terracota-deep" data-id="element-108" data-mp="3f0btv60rnlzy">
              {commerce.contactEmail}
            </a>}
          <ul className="flex flex-wrap gap-x-5 gap-y-2" data-id="element-109" data-mp="2792cikpw05yt">
            {commerce.legalLinks.map(l => <li key={l.label} data-id="element-110" data-mp="23bcwozt1671v">
                {l.url.trim() ? <a href={l.url} className="underline decoration-pizarra/30 underline-offset-4 hover:text-terracota-deep" data-id="element-111" data-mp="2h7qi2k0oqslm">
                    {l.label}
                  </a> : <span className="text-pizarra-soft" data-id="element-112" data-mp="1ol5r3ko4giil">{l.label}</span>}
              </li>)}
          </ul>
          <p className="text-pizarra-soft" data-id="element-113" data-mp="1jj81m8p4orh7">© {year} Recursos Practic & Simple. Todos los derechos reservados.</p>
        </div>
      </div>
    </footer>;
}